module.exports = "<div>\n  text-editor works!\n</div>\n"